import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi, { HttpBackendOptions } from 'i18next-http-backend';

import numeral from 'numeral';
import 'numeral/locales/de';

const LOCALES = ['en', 'de'];

i18n
  .use(LanguageDetector)
  .use(HttpApi)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    fallbackLng: 'en',
    load: 'languageOnly',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    debug: process.env.NODE_ENV === 'development',
  });

i18n.on('languageChanged', (language) => {
  const locale = language.replace(/-\w+$/, '');

  if (LOCALES.includes(locale)) {
    numeral.locale(locale);
  }
});

export default i18n;
